import { render, staticRenderFns } from "./step4.vue?vue&type=template&id=12bcf249&scoped=true&"
import script from "./step4.vue?vue&type=script&lang=js&"
export * from "./step4.vue?vue&type=script&lang=js&"
import style0 from "./step4.vue?vue&type=style&index=0&id=12bcf249&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12bcf249",
  null
  
)

export default component.exports